import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { withRouterLegacy } from "core/routerUtils";
import {
  SeatingChartUsedSeats,
  SeatingChartAssign,
  SeatingChartDashboard,
  SeatingChartEquating,
} from "features/seating-chart";
import { Spinner } from "shared/components";
import { mapRegSummaries } from "features/seating-chart/selectors";
import {
  getAllMaterialTypesRoom,
  getRoomRanges,
} from "features/material-chain/selectors";
import * as materialChainActions from "features/material-chain/duck";
import * as roomActions from "features/room-builder/duck";
import * as seatingChartActions from "features/seating-chart/duck";

import { isEmpty } from "lodash";

import "./SeatingChartContainer.scss";

class SeatingChartContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const eventId = this.props.match.params.eventId;
    const roomId = this.props.match.params.roomId;
    const { actions } = this.props;

    actions.getRoomMaterials(roomId);
    actions.getTCEventMaterialTypes(eventId);
    actions.getRoom(roomId).then((room) => {
      if (!isEmpty(room.roomType)) {
        actions.getRoomTypeMaterialTypes(room.roomType.id);
      }
    });
    actions.getRegSummaries(roomId);
  }

  render() {
    const {
      room,
      roomTypeMaterialTypes,
      roomsRanges,
      match,
      regSummaries,
      loading,
    } = this.props;

    if (isEmpty(room) || room.loading || loading) {
      return <Spinner />;
    }

    return (
      <Routes>
        <Route
          index
          element={
            <SeatingChartDashboard
              history={this.props.history}
              location={this.props.location}
              roomId={match.params.roomId}
              eventId={match.params.eventId}
              room={room}
              regSummaries={regSummaries}
              roomTypeMaterialTypes={roomTypeMaterialTypes}
              roomsRanges={roomsRanges}
            />
          }
        />
        <Route
          path="seats-in-use"
          element={
            <SeatingChartUsedSeats
              history={this.props.history}
              eventId={match.params.eventId}
              room={room}
              seatsData={regSummaries}
              roomTypeMaterialTypes={roomTypeMaterialTypes}
            />
          }
        />
        <Route
          path="assign/:materialId"
          element={
            <SeatingChartAssign
              history={this.props.history}
              eventId={match.params.eventId}
              room={room}
              seatsData={regSummaries}
              roomTypeMaterialTypes={roomTypeMaterialTypes}
              roomsRanges={roomsRanges}
            />
          }
        />
        <Route
          path="equating/:materialId"
          element={
            <SeatingChartEquating
              history={this.props.history}
              eventId={match.params.eventId}
              room={room}
              seatsData={regSummaries}
              roomTypeMaterialTypes={roomTypeMaterialTypes}
              roomsRanges={roomsRanges}
            />
          }
        />
      </Routes>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.materialChain.loading || state.seatingChart.loading,
    room: state.roomOptions.room || {},
    roomTypeMaterialTypes: getAllMaterialTypesRoom(state),
    roomsRanges: getRoomRanges(state), //state.materialChain.roomMaterials || [],
    regSummaries: mapRegSummaries(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...materialChainActions,
        ...roomActions,
        ...seatingChartActions,
      },
      dispatch
    ),
  };
}

export default withRouterLegacy(
  connect(mapStateToProps, mapDispatchToProps)(SeatingChartContainer)
);

SeatingChartContainer.propTypes = {
  // Props from react-router (via withRouterLegacy)
  match: PropTypes.shape({
    params: PropTypes.shape({
      eventId: PropTypes.string.isRequired,
      roomId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,

  // Props from mapStateToProps
  loading: PropTypes.bool,
  room: PropTypes.shape({
    loading: PropTypes.bool,
    roomType: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  roomTypeMaterialTypes: PropTypes.array.isRequired,
  roomsRanges: PropTypes.array.isRequired,
  regSummaries: PropTypes.array.isRequired,

  // Props from mapDispatchToProps
  actions: PropTypes.shape({
    getRoomMaterials: PropTypes.func.isRequired,
    getTCEventMaterialTypes: PropTypes.func.isRequired,
    getRoom: PropTypes.func.isRequired,
    getRoomTypeMaterialTypes: PropTypes.func.isRequired,
    getRegSummaries: PropTypes.func.isRequired,
  }).isRequired,
};
